import React, { Component } from "react";
import { matchPath } from "react-router";
import { Link } from "react-router-dom";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  Creators as StoresActions,
  Selectors as StoresSelectors,
} from "store/ducks/stores";

import { Page, Form, Loading, Breadcrumbs } from "components";

class Edit extends Component {
  state = {
    data: {
      external_store_id: "",
      percentage_ead: 0,
      name: "",
      score: false,
      presential_docs: true,
      state: null,
      external_catalog: "",
    },
    breadcrumbs: [
      { name: "Home", to: "/" },
      { name: "Pontos", to: "/points" },
      { name: "Lojas", to: "/points/stores" },
      { name: "Loja", to: "" },
    ],
  };

  componentDidMount() {
    this.props.getStoreRequest(this.handleGetID());
    this.props.getStoreStatesRequest();
  }

  componentDidUpdate(oldProps) {
    const { data } = this.state;
    const { store } = this.props;

    if (oldProps.store.loading && !store.loading) {
      this.setState({
        data: {
          ...data,
          external_store_id: store.data.attributes.external_store_id,
          name: store.data.attributes.name,
          score: store.data.attributes.score,
          external_catalog: store.data.attributes.external_catalog,
          presential_docs: store.data.attributes.presential_docs,
          percentage_ead: store.data.attributes.percentage_ead || 0,
          active: store.data.attributes.score,
          state:
            store.data.attributes.state !== null
              ? {
                  value: store.data.attributes.state.id,
                  label: store.data.attributes.state.name,
                }
              : null,
        },
      });
    }
  }

  handleGetID = () => {
    const match = matchPath(this.props.location.pathname, {
      path: "/points/stores/:id/edit",
    });
    const { id } = match.params;

    return id;
  };

  handleChange = (input, value) => {
    const { data } = this.state;

    this.setState({ data: { ...data, [input]: value } });
  };

  handleToggleActive = () => {
    const { data } = this.state;

    this.setState({ data: { ...data, score: !data.score } });
  };

  handleTogglePresentialDocs = () => {
    const { data } = this.state;

    this.setState({ data: { ...data, presential_docs: !data.presential_docs } });
  };

  handleSelectState = (state) => {
    const { data } = this.state;

    this.setState({ data: { ...data, state } });
  };

  handleSubmit = (e) => {
    e.preventDefault();

    const { data } = this.state;

    this.props.updateStoreRequest(this.handleGetID(), {
      place: {
        score: data.score,
        user_state_id: data.state.value,
        percentage_ead: data.percentage_ead,
        presential_docs: data.presential_docs,
        external_catalog: data.external_catalog,
      },
    });
  };

  render() {
    const { data, breadcrumbs } = this.state;
    const { update, states } = this.props;

    return (
      <Page>
        <Breadcrumbs breadcrumbs={breadcrumbs} />

        <Form className="page-form">
          <h3 className="form-title">Loja</h3>

          <Form.Field>
            <Form.Label>Código</Form.Label>
            <Form.Input
              name="code"
              placeholder="001"
              value={data.external_store_id}
              readOnly
            />
          </Form.Field>

          <Form.Field>
            <Form.Label>Loja</Form.Label>
            <Form.Input
              name="store"
              placeholder="Interlagos"
              value={data.name}
              readOnly
            />
          </Form.Field>

          <Form.Field className="field-select">
            <Form.Label>Estado</Form.Label>
            <Form.Select
              placeholder="Selecione o Estado"
              onChange={this.handleSelectState}
              value={data.state}
              options={states}
            />
          </Form.Field>

          <Form.Field>
            <Form.Label>Percentual EAD</Form.Label>
            <Form.Input
              name="code"
              placeholder="001"
              value={data.percentage_ead || 0}
              onChange={(e) =>
                this.handleChange("percentage_ead", e.target.value)
              }
            />
          </Form.Field>

          <Form.Field>
            <Form.Label>Catálogo Externo</Form.Label>
            <Form.Input
              name="store"
              placeholder="81018:62060"
              value={data.external_catalog || ""}
              onChange={(e) =>
                this.handleChange("external_catalog", e.target.value)
              }
            />
          </Form.Field>

          <Form.Field className="checkbox-field">
            <Form.Label>Presential Docs</Form.Label>
            <Form.Checkbox
              checked={data.presential_docs}
              onChange={this.handleTogglePresentialDocs}
            />
          </Form.Field>

          <Form.Field className="checkbox-field">
            <Form.Label>Ativar Loja</Form.Label>
            <Form.Checkbox
              checked={data.active}
              onChange={this.handleToggleActive}
            />
          </Form.Field>

          <div className="buttons">
            <Link to="/points/stores" className="button-cancel">
              Cancelar
            </Link>

            <Form.Button
              className="button-save"
              onClick={this.handleSubmit}
              disabled={update.loading}
            >
              {update.loading ? (
                <Loading type="btn" size="small" text="Salvando..." />
              ) : (
                "Salvar"
              )}
            </Form.Button>
          </div>
        </Form>
      </Page>
    );
  }
}

const mapState = (state) => ({
  store: state.stores.detail,
  update: state.stores.update,
  states: StoresSelectors.states(state.stores.states.data),
});

const mapActions = (dispatch) => bindActionCreators(StoresActions, dispatch);

export default connect(mapState, mapActions)(Edit);
